import React, {useEffect, useContext} from "react"
import Column from "@amzn/meridian/column"
import Row from "@amzn/meridian/row";
import RadioButton from "@amzn/meridian/radio-button"
import {ReceiveGroupByContext} from "./context/ReceiveGroupByContext";
import {FormattedMessage, injectIntl} from "react-intl";
import Tag from "@amzn/meridian/tag";
import {getFeaturesFromParent, getNodeCapabilityFromParent} from "../handler/ParentDataHandler";
import {chainWalk, parseCapabilitiesResponse} from "../util/Util";
import {ACTION_TYPE, FEATURES} from "../util/Constants";
import {ConfigContext} from "../global/context/ConfigContext";
import {MobileDisplay} from "../common/MobileDisplay";
import {useDeviceLayout} from "../common/context/DeviceLayoutContext";
import FilterExpander from "../common/FilterExpander";

const ReceiveGroupBy = ({ intl }) => {
    const { groups, dispatch } = useContext(ReceiveGroupByContext)
    const {configDispatch, configViewModel} = useContext(ConfigContext);
    const {isMobile} = useDeviceLayout();

    useEffect(() => {
        getNodeCapabilityFromParent().then(capabilityResponse => {
            const capability = parseCapabilitiesResponse(capabilityResponse)
            getFeaturesFromParent([FEATURES.IS_CPT_FILTER_ENABLED]).then(featureStatus => {
                configDispatch({type: ACTION_TYPE.GET_FEATURES_STATUS, featureStatus: featureStatus.data});
                if (isCPTFilterEnabled) {
                    dispatch({ type: 'FETCH_CPT', data:{dispatcher: dispatch, capability: capability}});
                } else {
                    dispatch({ type: 'INITIALIZE_GROUPS', capability});
                }
            })
        })
    }, []);

    const isCPTFilterEnabled = chainWalk(() => configViewModel.featureStatus[FEATURES.IS_CPT_FILTER_ENABLED], false);

    const renderGroupRadioButton = (group) => (
        <RadioButton 
            key={group.value} 
            value={group}
            checked={groups.selectedGroup.value === group.value}
            onChange={(data) => dispatch({ type: 'SELECT_GROUP', selectedGroup: data })}
        >
            {group.displayName}
        </RadioButton>
    );

    const renderFilterTag = () => (
        <div className="filter-tag">
            <Tag key={groups.selectedGroup.value} type="theme">
                {groups.selectedGroup.displayName}
            </Tag>
        </div>
    );

    const renderRadioButtons = () => {
        const groupsToRender = isCPTFilterEnabled ? groups.allGroupsWithCPT : groups.allGroupsWithCycle;
        
        return(
            <React.Fragment>
                <FormattedMessage id="receive.group_by" defaultMessage="Group by"/>
                {groupsToRender.map(renderGroupRadioButton)}
                {isMobile && (
                    <Row width="100%" spacingInset="none none small none">
                        {renderFilterTag()}
                    </Row>
                )}
            </React.Fragment>
        )
    }

    return (
        <Column spacing="small" spacingInset="none none medium none" alignmentHorizontal={"left"}>
            {isMobile ?
                <FilterExpander>
                    <Column width="100%" spacingInset="small" backgroundColor="secondary">
                        {renderRadioButtons()}
                    </Column>
                </FilterExpander> :
                <Row width="100%" spacingInset="medium large" backgroundColor="secondary">
                    {renderRadioButtons()}
                </Row>
            }
            <MobileDisplay visibility={false}>
                <Row width="100%" spacingInset="none">
                    {renderFilterTag()}
                </Row>
            </MobileDisplay>
        </Column>
    )
}

export default injectIntl(ReceiveGroupBy);


// WEBPACK FOOTER //
// ./src/components/receive/ReceiveGroupBy.js